import { render, staticRenderFns } from "./view-vessel.vue?vue&type=template&id=926ac1b6&scoped=true"
import script from "./view-vessel.vue?vue&type=script&lang=js"
export * from "./view-vessel.vue?vue&type=script&lang=js"
import style0 from "./view-vessel.vue?vue&type=style&index=0&id=926ac1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926ac1b6",
  null
  
)

export default component.exports